export default __webpack_public_path__ + "static/media/cancel.c64854de.svg";